module.exports = __webpack_public_path__ + "img/member_signIn_icon_431006.b763ec9d.png";